// extracted by mini-css-extract-plugin
export default {"wrapper":"IlumaEvent_wrapper__xLGZE","eventContainer":"IlumaEvent_eventContainer__ELB7l","badges":"IlumaEvent_badges__FokmP"};